import { Chip, Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";

const tone = {
  real: "success",
  partial: "warning",
  demo: "info",
  mock: "secondary",
};

const DataModeBadge = ({ mode = "real", label, source, size = "small" }) => {
  const { t } = useTranslation();
  const resolvedLabel = label || t(`platform.dataMode.${mode}`, mode);
  return (
    <Tooltip title={source || resolvedLabel}>
      <Chip size={size} color={tone[mode] || "default"} variant="outlined" label={resolvedLabel} sx={{ fontWeight: 600 }} />
    </Tooltip>
  );
};

export default DataModeBadge;
